module.exports = __webpack_public_path__ + "img/mobile_01.8c77ac28.jpg";